import { Component, Inject, Input, Output, EventEmitter } from '@angular/core';
import { Observable, BehaviorSubject, ReplaySubject, Subject, combineLatest, forkJoin, merge, of } from 'rxjs';
import { AccesService } from '../services/acces.service';
import { AccesTLR } from '../entities/acces-tlr.entity';
import { StaticTypeService } from '../../../../static-types/services/static-types.service';
import { AccesControleSecurite } from '../../../../static-types/entities/acces-controle-securite.entity';
import { AccesSearchResult } from '../entities/acces-search-result';
import { SubjectRelay } from '../../../../shared/commands/subject-relay.class';

@Component({
	selector: 'controle-securite-dialog',
	templateUrl: 'controle-securite-dialog.html',
	styleUrls: ['controle-securite-dialog.css'],
})
export class ControleSecuriteDialogComponent {

	acces!: AccesTLR;
	displaySubject = new Subject<boolean>();
	controleSecurite: number | null = null;
	controlesSecurite$!: Observable<AccesControleSecurite[]>
	protected displayCommandsSubject = new SubjectRelay<number>();
	rienASignaler: boolean = true;

	@Input()
	set displayCommands(obs: Observable<number> | undefined) {
	    this.displayCommandsSubject.registerSource(obs);
	}
	
	@Output() autorisationRequested = new EventEmitter<number | null>();
	
	constructor(
		@Inject(AccesService) private accesService: AccesService,
		@Inject(StaticTypeService) private staticTypeService: StaticTypeService,
	) {
		this.displayCommandsSubject.subscribe(
		    (accesId: number) => {
				this.resetForm();
		        this.controleSecurite = null;
		        this.accesService.getById(accesId).subscribe(
		            acces => {
		                this.acces = acces;
		                this.displaySubject.next(true);
		            }
		        );
		    }
		);
		
		this.controlesSecurite$ = staticTypeService.getAccesControleSecuriteList();
	}
	
	autoriser() {
	    this.displaySubject.next(false);
	    this.autorisationRequested.emit(this.controleSecurite);
	}
	
	rienASignalerChange() {
	  if (!this.rienASignaler) {
	    this.controleSecurite = null;
	  }
	}
	
	private resetForm() {
	    this.controleSecurite = null;
	    this.rienASignaler = true;
	}
	
	annuler() {
	  this.controleSecurite = null;
	  this.rienASignaler = true;
	  this.displaySubject.next(false);
	}
	
}